import type { ReactNode } from "react";
import clsx from "clsx";
import s from "./Container.module.scss";

type Props = {
  children: ReactNode;
  className?: string;
};

export default function Container({ children, className }: Props) {
  return <div className={clsx(s.container, className)}>{children}</div>;
}